<template>
	<v-card 
		outlined 
		width = "200px" 
		style = "width 		  : 100%; 
						 height 		: 100%; 
						 object-fit : fill;
						 overflow-y : hidden;"
		:ref = "'height_counter_'+layout_id"
		tile
		:loading="loading?'warning':false"
	>
		<v-card-title :class = "`caption pa-0 ma-0 blue vue-draggable-handle`">	 
			<!-- ${'orange darken-2'} -->
	    	<v-icon x-small color="white" class="ml-1">mdi-chart-timeline-variant</v-icon>
	  		<MenuAnalytic
	  			:inputField="info"
	  			keyField="analytic"
	  			AutoValueField="name"
	  			:key="layout_id+'MenuAnalytic'"
	  			valueField="name"
	  			:isXSmall="true"
	  			:isMultiple="false"
	  			:isLabel="true"
	  		></MenuAnalytic>
	    	<v-spacer></v-spacer>						
	    	<v-btn icon small @click="refreshComponent()">	    		
	    		<v-icon small class="mx-3"  v-if="show_options.refresh" :key="'refresh_'+layout_id">mdi-refresh</v-icon>
	    	</v-btn>
	    	<MenuDevice
	  			:inputField="info"
	  			keyField="deviceId"
	  			:isXSmall="true"
	  			:isMultiple="true"
	  			v-if="show_options.deviceId && !['data', 'smart_event'].includes(info.analytic)"
	  			valueField="deviceId"
	  			:key="layout_id+'MenuDevices'"
	  			:isReturnObject="true"
	  			@returnDevices="renderDevices($event)"
	  		></MenuDevice>
	  		<MenuDateTimes
	  			:inputField="info"  			
	  			keyFieldDates="dates"			
	  			:isXSmall="true"
	  			:isMultiple="true"
	  			:key="layout_id+'MenuDateTimes'"
	  			:reference="layout_id+'MenuDateTime'"
	  			v-if="show_options.dates"
	  			@receiveConfirm="refreshComponent()"
	  		></MenuDateTimes>
	  		
	    	<v-btn icon x-small outlined class="error mx-1" @click="$emit('close_component', layout_id)" v-show="show_options.close">
	        	<v-icon small outlined color  = "white" v-text = "'mdi-close'"></v-icon>
	      	</v-btn>	
    	</v-card-title>		      	
		<v-card-text class = "pa-1 pb-0 pt-1 no-drag text-center">	
		    <v-row no-gutters justify="center" align="center"
		    	:style = "`overflow-y : auto; overflow-x : hidden; height: ${height_counter}px;`"
		    >
		    	<!-- Fields -->
		    	<v-col cols="6" v-if="show.fields">		    					    			    			
		    		<MenuAnalytic
			  			:inputField="info"
			  			keyField="analytic"
			  			AutoSetField="analytic"
			  			AutoValueField="name"
						valueField="name"
			  			:isXSmall="false"
			  			:isMultiple="false"
			  			:isLabel="false"
			  			:isIcon="true"
			  			:isBlock="true"
	  					:isInput="true"
	  					:key="layout_id+'MenuAnalytic1'"

			  		></MenuAnalytic>		    	
			    </v-col>
			    <v-col cols="6" v-if = "show.fields">		    					    			    			
		    		<MenuTagCounter
			  			:inputField="info"
			  			keyField="tag"
			  			:fieldLink="info.analytic"
	  					valueField="name"
			  			AutoSetField="tag"
			  			AutoValueField="name"			  			  			
			  			:isXSmall="false"
			  			:isMultiple="false"
			  			:isLabel="false"
	  					:isInput="true"
			  			:isBlock="true"
			  			:isIcon="true"
			  			:key="'menu_field_tag'+layout_id"
			  		></MenuTagCounter>		    	
			    </v-col>
			    
		    	<v-col cols="6" v-if = "show.fields && show.deviceId && !['data', 'smart_event'].includes(info.analytic)">		    					    			    					    	
			    	<MenuDevice
			  			:inputField="info"
			  			keyField="deviceId"
			  			:isXSmall="false"
			  			:isMultiple="true"			  			
			  			:isLabel="true"			  			
			  			:isBlock="true"
			  			:isReturnObject="true"
			  			valueField="deviceId"
	  					@returnDevices="renderDevices($event)"
	  					:key="layout_id+'MenuDevices1'"
			  		></MenuDevice>
			  	</v-col>
		    	<v-col cols="6" v-if = "show.fields">		    					    			    					  	
			  		<MenuDateTimes
			  			:inputField="info"  			
			  			keyFieldDates="dates"			
			  			:isXSmall="false"
			  			:isMultiple="true"
			  			:reference="layout_id+'MenuDateTime'"			  			
			  			:isLabel="true"
			  			:isBlock="true"
	  					:key="layout_id+'MenuDateTimes1'"
			  		></MenuDateTimes>				
			  	</v-col>
			  	<v-col cols="6" v-if = "show.fields && ['smart_event'].includes(info.analytic)" >		 
					<v-checkbox v-model="info.isHistory" :label="$ml.get('historical_asset')"></v-checkbox>
			  	</v-col>
			  	<v-col cols="12">
			  		<v-btn
		    			small
		    			v-if 	 = "show.fields"
		    			color  = "primary"
		    			v-text = "$ml.get('save')"
		    			@click = "save()"
						:key = "'btn_save_'+layout_id"
		    		></v-btn>
			  	</v-col>
		    	
		    	<!-- Counter -->
			  	<v-col
	    			xl 		= "6"
	    			lg 		= "6"
	    			md 		= "6"
	    			sm 		= "6"
	    			xs 		= "6"
	    			cols 	= "6"
	    			v-if = "show.tag"
	    		>
	    			<MenuTagCounter
			  			:inputField="info"
			  			keyField="tag"
	  					valueField="name"
			  			:fieldLink="info.analytic"
			  			AutoSetField="tag"
			  			AutoValueField="name"					
			  			:isXSmall="false"
			  			:isMultiple="false"
			  			:isLabel="true"
	  					:isInput="false"
			  			:isBlock="false"
			  			:isIcon="true"
			  			:isLarge="true"
			  			:isCounter="true"
						:key="'counter_'+layout_id"
			  		></MenuTagCounter>		
	    		</v-col>
	    		<v-col
	    			xl 		= "6"
	    			lg 		= "6"
	    			md 		= "6"
	    			sm 		= "6"
	    			xs 		= "6"
	    			cols 	= "6"
	    			v-if = "show.counter"
	    		>
	    			<strong :class = "`text-${renderSizeCounts} font-weight-bold ${Count < 0 ? 'error' : 'dark'}--text`">
		      			{{ Math.abs(Count) }}
		      		</strong>		      		
		      		<br>
		      		<strong> {{ $ml.get('total') }}</strong>
	    		</v-col>
	    		<v-col
	    			xl 		= "6"
	    			lg 		= "6"
	    			md 		= "6"
	    			sm 		= "6"
	    			xs 		= "6"
	    			cols 	= "6"
	    			v-if = "show.counter && info.analytic =='data'"
	    		>
	    			<span class="caption d-flex justify-center"> {{ renderOperation }}</span>
	    		</v-col>
	    		<!-- Table -->
	    		<v-col
		    		xl 		= "11"
	    			lg 		= "11"
	    			md 		= "11"
	    			sm 		= "12"
	    			xs 		= "12"
	    			cols 	= "12"
    				v-if = "show.table"
    				:key 	 = "layout_id + 'devs_counters'"
	    		>	    		
	    			<v-simple-table
			    		dense
              			fixed-header
		              	class                	= "elevation-5"                
              			:height             	= "(height_counter-150) + 'px'"
			    	>           
			    		<template v-slot:top v-if="['smart_event'].includes(info.analytic)">
						    <v-checkbox v-model="info.isHistory" :label="$ml.get('historical_asset')"></v-checkbox>
			    			<v-divider color="success"></v-divider>
			    			
			    		</template>    
				    	<template v-slot:default>
					      	<thead>
					        	<tr>
					          		<th class="text-left">{{ $ml.get("name") }}</th>
					          		<th class="text-left">{{ $ml.get("date") }}</th>
					          		<th class="text-left">{{ $ml.get("subtotal") }}</th>
					          
					        	</tr>
					      	</thead>
				    		<tbody>
					          	<tr v-for = "(item, key_dev, idx_dev) in renderCount.devices" :key="key_dev + idx_dev + layout_id+'_device'">
						            <td class = "text-left">{{ item.name }}</td>
						            <td class = "text-left">{{ item.date }}</td>
						            <td class = "text-left">{{ item.subtotal }}</td>
					          	</tr>

				        	</tbody>
				    	</template>
			    	</v-simple-table>	
		    	</v-col>
			</v-row>
		</v-card-text>	   
	    	 
  	</v-card>
</template>
<script>
	
	import dates 			from "@/components/info/dates.vue" 	
 	import EventBus 	from "@/event-bus"
 	import menus  		from "@/components/info/menus.vue"
 	import tags 			from "@/components/analytics/default_tags.js"
 	import MenuDevice from "@/components/info/MenuDevice.vue"
 	import MenuAnalytic from "@/components/counter/MenuAnalyticCounter.vue"
 	import MenuTagCounter from "@/components/counter/MenuTagCounter.vue"
 	import MenuDateTimes from "@/components/info/MenuDateTimes.vue"
 	import { mapGetters } from 'vuex';

	export default{
		name: "counter",
		props: [
			'info_to_component',
			'layout_id',
			'layout_end',
		], 
		components : {
			dates,
			menus,
			MenuDevice, MenuAnalytic, MenuTagCounter, MenuDateTimes
		},
		data: (vm) => ({
			// counts : 0,
			total : 0,
			height_counter :150,
			info 				: {
				analytic 		: 'analytics',
				tag 		 		: 'tag',
				dates 	 		: [],
				deviceId 		: [],
				devices 		: {},
				start 			: "00:00", 
				end 			: "23:59",		
				isHistory : true,		
				// Analytic 		: null,
				// Devices  		: [],
				// icon 		 		: 'mdi-vector-square',
				// device_name : "",
				// arr_devices : [],
			},
			show:{ // show body
				fields: true,
				operation : false,
				tag : false,
				counter : false,
				table : false,
				deviceId : true,
			},
			show_options : { // show bar
				deviceId 	: false,
				dates 		: false,
				close 		: true,
				analytic 	: true,
				tag 		: true,
				refresh 	: false,
			},
			headers : [
				{ text : vm.$ml.get("name") , value : "name"},
				{ text : vm.$ml.get("date") , value : "date"},
				{ text : vm.$ml.get("subtotal") , value : "subtotal"},
			],
			loading : false,			
		}), // data
		watch: {
			layout_end : function(v){
				this.onResize();
			}, //layout
			"info.tag"(val){
				// console.log("CHECK TAG render ", val, this.show.fields, this.show.counter)
				if (!this.loading) {

					if (this.show.fields) {
						this.renderTag(val);
					}else
					if (this.show.counter) {
						this.renderTag(val);		
						this.$nextTick(()=>{
							this.refreshComponent();
						})							
					}
				}
			},
			"info.deviceId"(val){
				if (this.show.counter && !this.loading && !['data', 'smart_event'].includes(this.info.analytic)) {
					this.refreshComponent();					
				}
			},
			"info.isHistory"(val){
				if (!this.show.fields) {
					this.refreshComponent();					
				}
			}
		}, // watch
		mounted(){
			this.$nextTick(()=>{
				this.onResize();
				this.renderCreated();
			})
		},
		beforeDestroy(){
			this.$store.commit("Counter/clearCount", this.layout_id);
		},
		computed:{
			currentUser(){
		      	return this.$store.state.auth.user;
		    }, // currentUser
			colsCounter(){
	    		let col = 4;
	    		// if(this.info && this.info.analytic == 'data') col=3;
	    		return col
	    	},
	    	renderSizeCounts(){
	    		if (this.Count < 1000) {
						return 'h2';
					}else
					if (this.Count > 1000) {
						return 'h3';
					}else
					if (this.Count > 10000) {
						return 'h4';						
					}
	    		return 'h2'
	    	},    		    	
	    	Conte(){
	    		return this.$store.getters["Counter/conte"];
	    	},
	    	Count(){	    		  		
	    		return this.Conte?this.renderCount.counts:0;//  
	    	},
	    	renderCount(){	    			    	
	    		return this.$store.getters["Counter/getCounterById"](this.layout_id);
	    	},
	    	renderOperation(){
	    		return this.renderCount?.Data?.operator || ''
	    	}
		},
		methods:{
			refreshComponent(){
				if (!this.loading) {					
					// this.clearDevicesSubtotal();
					this.save(); 
				}
			},
			onResize(){				
				if (this.$refs && this.$refs[`height_counter_${this.layout_id}`] && this.$refs[`height_counter_${this.layout_id}`]) {
					this.height_counter = this.$refs[`height_counter_${this.layout_id}`].$el.clientHeight - 20;
				}
			}, // onResize
			renderDevices(items){
				// console.log("Render devices ",items)
				if (items && items.length > 0) {
					items.forEach((it)=>{
						if (it) {
							if (this.info.devices && !this.info.devices[it.deviceId]) {
								this.info.devices[it.deviceId]={
									name : it.name,
									subtotal : 0,
									date : ""
								}
							}

						}
					})
				}else{
					this.info.devices={}					
				}
			},
			clearDevicesSubtotal(){				
				if (this.info && this.info.deviceId && this.info.deviceId.length) {
					const listTemp = this.$store.getters["Devices/list"] || [];						
					this.info.deviceId.forEach((it)=>{						
						if (this.info.devices[it]) {							
							this.info.devices[it].subtotal = 0;
							this.info.devices[it].date = "";
						}else{
							const find = listTemp.find(x=> x.deviceId == it);							
							this.info.devices[it]={
								subtotal : 0,
								date : "",
								name : find?.name || "",
							};
						}
					})
					
				}
			},
			renderCreated(){
				// console.log("info_to_component counter ", this.info_to_component)
				if (this.info_to_component && this.info_to_component.analytic && this.info_to_component.tag) {
					this.$nextTick(()=>{
						this.info = {...this.info_to_component};
						if (this.info.analytic == 'data' && !this.info.Data) {
							this.renderTag(this.info.tag)
						}
						if (this.info.dates){
							this.info.dates= this.formatRangeDates(this.info.start, this.info.end);//this.$Helper.formatDatePicker();							
						}
						
						this.refreshComponent();					
					})
				}
			},
			
			renderTag(item){ // name of smart event or data
				// console.log("RENDER TAG ", item, this.info.analytic)
				this.info.deviceId=[];
				this.info.devices={};
				if (this.info.analytic=='smart_event') {
					const listTemp = this.$store.getters["Tags/getBySelect"]("smart_event")?.list || [];						
					const find = listTemp.find(x=> x.name==item);
					if (find) {
						this.info.ruleId=find.id;
						this.info["Tag"]={name: find.name, id: find.id};
						this.info.deviceId=find.Detail_device_alarm.map(device=>device.deviceId) 
					}
					// console.log("Devices ", this.info.deviceId)
				}else{
					delete this.info.Tag;
				}
				if (this.info.analytic=='data') {
					const listTemp = this.$store.getters["Tags/getBySelect"]("data")?.list || [];		
					// if (listTemp) {}								
					const counter = listTemp.filter(counter=>item.toLowerCase()==counter.name.toLowerCase())[0]						
					// console.log("COUNTER STATISTICS --------", counter)
					if (counter) {					
						const regex 	= new RegExp('\\+|\\*|\\-|\\/', 'mg')
						const nameTags 	= counter.operator.split(regex);						
						const operatorTemp = counter.operator.match(regex)
						if (operatorTemp) {
							this.info.operator= operatorTemp[0];
						}
						this.info.Data=counter;  
						const tempListSmartEvent = this.$store.getters["Tags/getBySelect"]('smart_event')?.list || [];
						const find1 = tempListSmartEvent.find(x=> x.name==nameTags[0]);
						if (find1) {
							this.info.tag1 = {
								tag: find1.name,
								deviceId:find1.Detail_device_alarm.map(device=>device.deviceId),
								analytic: "smart_event",
								ruleId: find1.id,
								timeZone:this.$timezone,								
								counts : 0,								 
							}
							// this.info.deviceId = this.info.tag1.deviceId;
							this.info.devices.tag1={ name: find1.name, subtotal : 0 , date : "" };
						}
						const find2 = tempListSmartEvent.find(x=> x.name==nameTags[1]);
						if (find2) {
							this.info.tag2 = {
								tag: find2.name,
								deviceId:find2.Detail_device_alarm.map(device=>device.deviceId),
								analytic: "smart_event",
								ruleId: find2.id,
								timeZone:this.$timezone,								
								counts : 0,
							}
							this.info.devices.tag2={ name: find2.name, subtotal : 0 , date : "" };
						}
						this.info.deviceId=["tag1", "tag2"] //this.info.deviceId.concat(this.info.tag2.deviceId)
						// this.clearDevicesSubtotal();

					}
				}else{
					delete this.info.tag1;
					delete this.info.tag2;
					delete this.info.Data;
					delete this.info.operator;
				}
			},

			changeDate(item){ // update dates 
				if(this.info && item ){
					// const { time } = item;
					// const hour = this.$moment(time).format("HH:mm");								
					// if(hour == this.info.start){
						this.info.dates = this.formatRangeDates(this.info.start, this.info.end);
						this.refreshComponent();						 	
					// }			
				}
			},
			formatRangeDates(start, end){
				let dates 		= this.$Helper.formatDatePicker();
				let dateStart 	= this.$momentz.tz(dates[0] + " " + start,  this.$timeZone)
				let dateEnd   	=  this.$momentz.tz(dates[1] + " " + end, this.$timeZone)
				let newDate 	= dateEnd.clone().add(1, 'days');
				// const diff 		= dateEnd.diff(dateStart, 'hours')
				// if (diff <= 1 ) {
				if (start == '00:00') {
					dates[1] = dates[0];			
				}else{
					dates[1] = newDate.format('YYYY-MM-DD');
				}
				return dates;
			}, // formatRangeDates

			async renderCounter(){
				if (this.info.analytic == 'smart_event') {					
					if (this.info && this.info.isHistory) {
						const res = await this.get_statics({...this.info});
						if (res && res.length) {
							let contTotal = 0;
							res.forEach((it)=>{
								const subTotal=parseInt(it.subtotal);
								contTotal+=subTotal;
								this.$store.commit("Counter/addCountDevice",{layout_id : this.layout_id , ...it, subtotal : subTotal})		
							})
						}
					}

				}else if (this.info.analytic == 'data') {
					let contTotal1 = 0;
					if (this.info && this.info.tag1) {												
						const res1 = await this.get_statics({...this.info.tag1, dates: this.info.dates, start : this.info.start, end : this.info.end });
						if (res1 && res1.length) {
							res1.forEach((it)=>{														
								const subTotal=parseInt(it.subtotal);
								contTotal1+=subTotal;
							})					
						}
						
					}
					let contTotal2 = 0;
					if (this.info && this.info.tag2) {										
						const res2 = await this.get_statics({...this.info.tag2, dates: this.info.dates, start : this.info.start, end : this.info.end});
						if (res2 && res2.length) {
							res2.forEach((it)=>{														
								const subTotal=parseInt(it.subtotal);
								contTotal2+=subTotal;							
							})
						}					
					}
					// console.log("COUNT DATa ", this.layout_id, contTotal1, contTotal2, this.info?.operator)
					this.$store.commit("Counter/addCountData",{  
						layout_id: this.layout_id, 
						count1 : contTotal1, 
						count2: contTotal2, 
						operator : this.info?.operator
					});

				}else if(this.info.analytic != 'objects'){
					const res = await this.get_statics(this.info);
					if (res && res.length) {
						res.forEach((cont)=>{
							if (cont) {
								const contt = parseInt(cont.subtotal); 
								contTotal+= contt;

								this.renderCount.devices[cont.deviceId].date 			=  cont && cont.unix_itme_stamp ? this.$Format.format_date(cont.unix_itme_stamp) : cont.timestamp ? this.$Format.format_date(cont.timestamp) : this.$Format.format_date(cont.updatedAt, 'createdAt');
							}
						})						
						this.$store.commit("Counter/addCount", {count : contTotal, layout_id:this.layout_id })
					}
				}
				this.loading=false;

			},

			save(){
				this.loading=true;
				this.clearDevicesSubtotal();
				// show menu
				this.show.counter  	= true;
				this.show.tag		= true;
				this.show.fields	= false;
				this.show.table		= true;
				this.show_options.dates 	= true;
				this.show_options.deviceId 	= true;
				this.show_options.refresh 	= true;
				if (['smart_event', 'data'].includes(this.info.analytic)) {
					this.show_options.deviceId 	= false;						
				}
				// valid dates
				if (this.info && this.info.dates && this.info.dates.length == 0){
					this.info.dates=this.$Helper.formatDatePicker();
				}				
				// start counter
				// this.$store.commit("Counter/clearCount",this.layout_id)
				// const timer=setTimeout(()=>{
				this.$store.commit("Counter/setCount", {...this.info, layout_id:this.layout_id, counts:0, actionDate:this.changeDate});
				// update dashboard
				if (this.layout_id) {						
					this.$nextTick(()=>{									
						this.$emit('update_of_component',{
							component : "counter",
							value 	  : { ...this.info },
							ID 		  	: this.layout_id,
						});
					})
				}
				// get list
				// console.log("CHECK REnder")
				this.renderCounter()				
				// },500)
				
			},
			async get_statics(item){
				let info_up = {};			
				let dates1 = this.$Format.format_date_picker(item.dates);
				let datess = this.$Format.format_date_time(dates1,{
						start : item.start || '00:00',
						end 	: item.end || '23:59'
					}, true, false);				
				if (datess) {
					info_up.start	= datess.start;
					info_up.end	 	= datess.end;
				}			
				info_up.timeZone 	= this.$timezone;
				info_up.tag 		= item.tag;
				info_up.analytic	= item.analytic;
				if(item.deviceId){
					info_up.deviceId=item.deviceId;
				}
				if (item.ruleId) {
					info_up.ruleId = item.ruleId;
				}
				let api = this.$URL + '/api/v1/alerts/stats';
				if (!["objects","data"].includes(info_up.analytic) ) {


					return await this.$axios.post(api, info_up).then( res => {
						if (res && res.data && res.data.rows && res.data.rows.length > 0) {					
							let count = 0;
							return res.data.rows
							// .forEach((cont)=>{
							// 	if (cont) {
							// 		count += parseInt(cont.subtotal);														
							// 	}
							// })
							// console.log("get data  : ", info_up.tag,   this.counts, count)
							// return count;
						}
						
					}).catch( er => {
						console.warn("Error get info statics ", er)
					});
				}else{
					return null
				}
			}, // get statics
		}
	};
</script>